import Notify from "vue-notifyjs";
import SideBar from "@/core/components/SidebarPlugin";
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import FilterCollapsePlugin from "./filterCollapse";
import DraggableModalPlugin from "./draggableModal";
import "es6-promise/auto";

//css assets
import "bootstrap/dist/css/bootstrap.css";
import "@/core/assets/sass/style.scss";
import "@/core/assets/css/themify-icons.css";

export default {
  install(Vue) {
    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(FilterCollapsePlugin);
    Vue.use(DraggableModalPlugin);
    Vue.use(SideBar);
    Vue.use(Notify, {
      timeout: 3000,
    });
  },
};
